import { render, staticRenderFns } from "./creatAgreement.vue?vue&type=template&id=c84169b0&scoped=true"
import script from "./creatAgreement.vue?vue&type=script&lang=js"
export * from "./creatAgreement.vue?vue&type=script&lang=js"
import style0 from "./creatAgreement.vue?vue&type=style&index=0&id=c84169b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84169b0",
  null
  
)

export default component.exports